
export default function LiveNoMobile() {
    return (
        <div className="wf-section">
            <h5 className="heading">Sorry, this content is not available on mobile devices due to broadcasting rights being sold.</h5>
        </div>
    );
}
